import _ from "lodash";
/**-- external -- */
import React from "react";
import { connect } from "react-redux";

/**-- internal -- */
import { useI18n } from "Hooks";
import {
  JUMP_TO_COLUMNS,
  trackJumpToCardClick,
} from "GlobalHeader/modules/Utils";
import {
  getIsCombineCurriculumHomePageEnabled,
  GLOBAL_HEADER_SHORTCUTS_MAPPING,
} from "Platform/modules/PlatformUtils";
import {
  getModuleLabel,
  getFeatureIcon,
  FEATURE_STYLE_MAP,
} from "Courses/components/TeacherCourses/Utils";
import { getModuleSubLabel } from "AppComponents/GlobalSearchBarV2/components/Utils";
import { navigateToFeature } from "Courses/components/TeacherCourses/module/Module";

/** -- relative -- */
import { ModuleCard } from "GlobalHeader/components/JumpToFeature/commonComponents";
import { getBehaviourNomenclatureFromCache } from "BehaviourConfiguration/modules/BehaviourConfigurationGraphqlHelpers";
import { getOrganizationId } from "modules/CommonSelectors";

const HomepageFeatureCard = props => {
  const {
    testId,
    feature,
    userType,
    organizationId,
    navigateToFeature,
    onNavigationDone,
    columnIndex,
    behaviourNomenclatureConstants,
    currentCurriculumProgramId,
  } = props;

  const { t } = useI18n([
    "announcement",
    "classRoom",
    "calendar",
    "attendance",
    "studentGoals",
    "progressReport",
    "teacherHomePage",
    "project",
    "common",
    "onBoarding",
    "snp",
    "journal",
  ]);

  const localTestId = `${testId}-moduleCard-${feature}`;

  const onCardClick = e => {
    const isMouseClick = !!e.isTrusted;

    trackJumpToCardClick({
      e,
      featureType: JUMP_TO_COLUMNS.HOMEPAGE_FEATURES,
      featureId: feature,
      isMouseClick,
    });

    navigateToFeature({
      feature,
      allowCrossCurriculumNavigation: !getIsCombineCurriculumHomePageEnabled(),
      t,
      appendCurriculumIdInQueryParam: true,
      currentCurriculumProgramId,
    });
    onNavigationDone();
  };

  return (
    <ModuleCard
      icon={getFeatureIcon({ feature, height: 40, width: 40 })}
      iconStyle={FEATURE_STYLE_MAP[feature]}
      label={getModuleLabel({
        t,
        feature,
        userType,
        organizationId,
        behaviourNomenclatureConstants,
      })}
      subLabel={getModuleSubLabel({
        t,
        feature,
      })}
      onCardClick={onCardClick}
      testId={localTestId}
      shortcutKey={_.get(
        GLOBAL_HEADER_SHORTCUTS_MAPPING,
        [feature, "shortcutKey"],
        null
      )}
      columnIndex={columnIndex}
    />
  );
};

const mapStateToProps = state => {
  const organizationId = getOrganizationId(state);

  const behaviourNomenclatureConstants = getBehaviourNomenclatureFromCache({
    organizationId,
  });

  return { behaviourNomenclatureConstants };
};

const mapActionCreators = {
  navigateToFeature,
};

export default connect(mapStateToProps, mapActionCreators)(HomepageFeatureCard);
